import initialState from './state'

export function resetState(state) {
  Object.assign(state, initialState())
}

export function setCategories(state, value) {
  state.categories = value
}
